import React from "react";
import { Field } from "formik";
import FormContainer from "forms/components/FormContainer";
import FormRow from "forms/components/FormRow";
import { RenderTypeahead } from "forms/fields";
import PropTypes from "prop-types";

import { Translate } from "utils";

const { t } = new Translate("BrokerInviteForm");

const Broker = ({ formik: { setFieldValue, values } }) => {
  const companyID = values.company && values.company.id;
  const searchParameters = {
    facets: "company_id, is_owner",
    filters: `${companyID ? `company_id:${companyID} AND ` : ""}is_owner:false`,
  };

  const onChange = (obj, field) => setFieldValue(obj, { ...values[obj], id: undefined, ...field });
  const onSelectUser = ({ company, email, id, name }) => {
    setFieldValue("user", { id, email, name });
    setFieldValue("company", company);
  };
  const onSelectCompany = ({ id, name }) => setFieldValue("company", { id, name });

  return (
    <FormContainer title={t("broker")}>
      <FormRow>
        <Field
          component={RenderTypeahead}
          label={t("name")}
          name="user.name"
          onChange={(name) => onChange("user", { name })}
          onSelect={onSelectUser}
          searchIndex="Broker_by_name_email"
          searchKey="name"
          searchParameters={searchParameters}
          autoFocus
        />
        <Field
          component={RenderTypeahead}
          label={t("company")}
          name="company.name"
          onChange={(name) => onChange("company", { name })}
          onSelect={({ company }) => onSelectCompany(company)}
          searchIndex="Broker_by_company"
          searchKey="company.name"
          searchParameters={searchParameters}
        />
      </FormRow>
      <FormRow>
        <Field
          component={RenderTypeahead}
          label={t("email")}
          name="user.email"
          onChange={(email) => onChange("user", { email })}
          onSelect={onSelectUser}
          searchIndex="Broker_by_name_email"
          searchKey="email"
          searchParameters={searchParameters}
        />
      </FormRow>
    </FormContainer>
  );
};

Broker.propTypes = {
  formik: PropTypes.shape({
    values: PropTypes.shape({
      company: PropTypes.shape({
        id: PropTypes.number,
      }),
    }),
    setFieldValue: PropTypes.func,
  }),
};

export default Broker;
